@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-327_314_016)
internal val Res.drawable.U7: DrawableResource by lazy {
      DrawableResource("drawable:U7", setOf(
        ResourceItem(setOf(), "${MD}drawable/U7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-87_789_955)
internal val Res.drawable.U8: DrawableResource by lazy {
      DrawableResource("drawable:U8", setOf(
        ResourceItem(setOf(), "${MD}drawable/U8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_144_970_366)
internal val Res.drawable.U9: DrawableResource by lazy {
      DrawableResource("drawable:U9", setOf(
        ResourceItem(setOf(), "${MD}drawable/U9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-948_130_064)
internal val Res.drawable.V1: DrawableResource by lazy {
      DrawableResource("drawable:V1", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-710_656_992)
internal val Res.drawable.V10: DrawableResource by lazy {
      DrawableResource("drawable:V10", setOf(
        ResourceItem(setOf(), "${MD}drawable/V10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_416_526_321)
internal val Res.drawable.V11: DrawableResource by lazy {
      DrawableResource("drawable:V11", setOf(
        ResourceItem(setOf(), "${MD}drawable/V11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-174_955_320)
internal val Res.drawable.V11A: DrawableResource by lazy {
      DrawableResource("drawable:V11A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V11A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_112_448_009)
internal val Res.drawable.V11B: DrawableResource by lazy {
      DrawableResource("drawable:V11B", setOf(
        ResourceItem(setOf(), "${MD}drawable/V11B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_530_168_208)
internal val Res.drawable.V11C: DrawableResource by lazy {
      DrawableResource("drawable:V11C", setOf(
        ResourceItem(setOf(), "${MD}drawable/V11C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_041_120_181)
internal val Res.drawable.V12: DrawableResource by lazy {
      DrawableResource("drawable:V12", setOf(
        ResourceItem(setOf(), "${MD}drawable/V12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-626_439_656)
internal val Res.drawable.V12A: DrawableResource by lazy {
      DrawableResource("drawable:V12A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V12A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_421_349_598)
internal val Res.drawable.V12B: DrawableResource by lazy {
      DrawableResource("drawable:V12B", setOf(
        ResourceItem(setOf(), "${MD}drawable/V12B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_697_961_916)
internal val Res.drawable.V13: DrawableResource by lazy {
      DrawableResource("drawable:V13", setOf(
        ResourceItem(setOf(), "${MD}drawable/V13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_557_983_175)
internal val Res.drawable.V14: DrawableResource by lazy {
      DrawableResource("drawable:V14", setOf(
        ResourceItem(setOf(), "${MD}drawable/V14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_425_919_159)
internal val Res.drawable.V15: DrawableResource by lazy {
      DrawableResource("drawable:V15", setOf(
        ResourceItem(setOf(), "${MD}drawable/V15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_882_898_035)
internal val Res.drawable.V16: DrawableResource by lazy {
      DrawableResource("drawable:V16", setOf(
        ResourceItem(setOf(), "${MD}drawable/V16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_947_820_065)
internal val Res.drawable.V17: DrawableResource by lazy {
      DrawableResource("drawable:V17", setOf(
        ResourceItem(setOf(), "${MD}drawable/V17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-70_066_038)
internal val Res.drawable.V18: DrawableResource by lazy {
      DrawableResource("drawable:V18", setOf(
        ResourceItem(setOf(), "${MD}drawable/V18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(100_601_051)
internal val Res.drawable.V19: DrawableResource by lazy {
      DrawableResource("drawable:V19", setOf(
        ResourceItem(setOf(), "${MD}drawable/V19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-551_210_862)
internal val Res.drawable.V1A: DrawableResource by lazy {
      DrawableResource("drawable:V1A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_693_506_207)
internal val Res.drawable.V1B: DrawableResource by lazy {
      DrawableResource("drawable:V1B", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_615_838_211)
internal val Res.drawable.V1C: DrawableResource by lazy {
      DrawableResource("drawable:V1C", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_105_181_321)
internal val Res.drawable.V1D: DrawableResource by lazy {
      DrawableResource("drawable:V1D", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-828_209_673)
internal val Res.drawable.V1E: DrawableResource by lazy {
      DrawableResource("drawable:V1E", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(866_846_233)
internal val Res.drawable.V1F: DrawableResource by lazy {
      DrawableResource("drawable:V1F", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_306_987_386)
internal val Res.drawable.V1G: DrawableResource by lazy {
      DrawableResource("drawable:V1G", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_036_703_244)
internal val Res.drawable.V1H: DrawableResource by lazy {
      DrawableResource("drawable:V1H", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-448_221_002)
internal val Res.drawable.V1I: DrawableResource by lazy {
      DrawableResource("drawable:V1I", setOf(
        ResourceItem(setOf(), "${MD}drawable/V1I.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_045_171_485)
internal val Res.drawable.V2: DrawableResource by lazy {
      DrawableResource("drawable:V2", setOf(
        ResourceItem(setOf(), "${MD}drawable/V2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-96_194_930)
internal val Res.drawable.V20: DrawableResource by lazy {
      DrawableResource("drawable:V20", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_162_976_730)
internal val Res.drawable.V20A: DrawableResource by lazy {
      DrawableResource("drawable:V20A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_206_027_783)
internal val Res.drawable.V20B: DrawableResource by lazy {
      DrawableResource("drawable:V20B", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_818_218_582)
internal val Res.drawable.V20C: DrawableResource by lazy {
      DrawableResource("drawable:V20C", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_884_336_101)
internal val Res.drawable.V20D: DrawableResource by lazy {
      DrawableResource("drawable:V20D", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(214_570_204)
internal val Res.drawable.V20E: DrawableResource by lazy {
      DrawableResource("drawable:V20E", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-898_331_437)
internal val Res.drawable.V20F: DrawableResource by lazy {
      DrawableResource("drawable:V20F", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_737_750_022)
internal val Res.drawable.V20G: DrawableResource by lazy {
      DrawableResource("drawable:V20G", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_341_068_122)
internal val Res.drawable.V20H: DrawableResource by lazy {
      DrawableResource("drawable:V20H", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_833_415_847)
internal val Res.drawable.V20I: DrawableResource by lazy {
      DrawableResource("drawable:V20I", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20I.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_627_472_749)
internal val Res.drawable.V20J: DrawableResource by lazy {
      DrawableResource("drawable:V20J", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20J.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-905_320_960)
internal val Res.drawable.V20K: DrawableResource by lazy {
      DrawableResource("drawable:V20K", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20K.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(61_892_230)
internal val Res.drawable.V20L: DrawableResource by lazy {
      DrawableResource("drawable:V20L", setOf(
        ResourceItem(setOf(), "${MD}drawable/V20L.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-164_159_865)
internal val Res.drawable.V21: DrawableResource by lazy {
      DrawableResource("drawable:V21", setOf(
        ResourceItem(setOf(), "${MD}drawable/V21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(330_531_135)
internal val Res.drawable.V22: DrawableResource by lazy {
      DrawableResource("drawable:V22", setOf(
        ResourceItem(setOf(), "${MD}drawable/V22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_403_483_977)
internal val Res.drawable.V23: DrawableResource by lazy {
      DrawableResource("drawable:V23", setOf(
        ResourceItem(setOf(), "${MD}drawable/V23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_198_771_487)
internal val Res.drawable.V23A: DrawableResource by lazy {
      DrawableResource("drawable:V23A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V23A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_227_373_131)
internal val Res.drawable.V24: DrawableResource by lazy {
      DrawableResource("drawable:V24", setOf(
        ResourceItem(setOf(), "${MD}drawable/V24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_074_395_252)
internal val Res.drawable.V25: DrawableResource by lazy {
      DrawableResource("drawable:V25", setOf(
        ResourceItem(setOf(), "${MD}drawable/V25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(71_903_389)
internal val Res.drawable.V26: DrawableResource by lazy {
      DrawableResource("drawable:V26", setOf(
        ResourceItem(setOf(), "${MD}drawable/V26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(767_961_153)
internal val Res.drawable.V27: DrawableResource by lazy {
      DrawableResource("drawable:V27", setOf(
        ResourceItem(setOf(), "${MD}drawable/V27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(346_274_561)
internal val Res.drawable.V28: DrawableResource by lazy {
      DrawableResource("drawable:V28", setOf(
        ResourceItem(setOf(), "${MD}drawable/V28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_621_494_300)
internal val Res.drawable.V28A: DrawableResource by lazy {
      DrawableResource("drawable:V28A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V28A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-895_853_129)
internal val Res.drawable.V29: DrawableResource by lazy {
      DrawableResource("drawable:V29", setOf(
        ResourceItem(setOf(), "${MD}drawable/V29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(670_748_369)
internal val Res.drawable.V29A: DrawableResource by lazy {
      DrawableResource("drawable:V29A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V29A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(140_723_070)
internal val Res.drawable.V2A: DrawableResource by lazy {
      DrawableResource("drawable:V2A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V2A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_347_826_699)
internal val Res.drawable.V3: DrawableResource by lazy {
      DrawableResource("drawable:V3", setOf(
        ResourceItem(setOf(), "${MD}drawable/V3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_152_285_422)
internal val Res.drawable.V30: DrawableResource by lazy {
      DrawableResource("drawable:V30", setOf(
        ResourceItem(setOf(), "${MD}drawable/V30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(685_163_375)
internal val Res.drawable.V30A: DrawableResource by lazy {
      DrawableResource("drawable:V30A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V30A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-107_271_843)
internal val Res.drawable.V31: DrawableResource by lazy {
      DrawableResource("drawable:V31", setOf(
        ResourceItem(setOf(), "${MD}drawable/V31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(471_368_821)
internal val Res.drawable.V31A: DrawableResource by lazy {
      DrawableResource("drawable:V31A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V31A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_146_573_250)
internal val Res.drawable.V32: DrawableResource by lazy {
      DrawableResource("drawable:V32", setOf(
        ResourceItem(setOf(), "${MD}drawable/V32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_360_755_197)
internal val Res.drawable.V33: DrawableResource by lazy {
      DrawableResource("drawable:V33", setOf(
        ResourceItem(setOf(), "${MD}drawable/V33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_699_317_316)
internal val Res.drawable.V33A: DrawableResource by lazy {
      DrawableResource("drawable:V33A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V33A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(335_820_302)
internal val Res.drawable.V34: DrawableResource by lazy {
      DrawableResource("drawable:V34", setOf(
        ResourceItem(setOf(), "${MD}drawable/V34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(732_749_243)
internal val Res.drawable.V35: DrawableResource by lazy {
      DrawableResource("drawable:V35", setOf(
        ResourceItem(setOf(), "${MD}drawable/V35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_451_438_947)
internal val Res.drawable.V36: DrawableResource by lazy {
      DrawableResource("drawable:V36", setOf(
        ResourceItem(setOf(), "${MD}drawable/V36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(840_209_823)
internal val Res.drawable.V37: DrawableResource by lazy {
      DrawableResource("drawable:V37", setOf(
        ResourceItem(setOf(), "${MD}drawable/V37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(321_161_880)
internal val Res.drawable.V37A: DrawableResource by lazy {
      DrawableResource("drawable:V37A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V37A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_928_715_601)
internal val Res.drawable.V38: DrawableResource by lazy {
      DrawableResource("drawable:V38", setOf(
        ResourceItem(setOf(), "${MD}drawable/V38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(433_169_328)
internal val Res.drawable.V39: DrawableResource by lazy {
      DrawableResource("drawable:V39", setOf(
        ResourceItem(setOf(), "${MD}drawable/V39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_211_340_865)
internal val Res.drawable.V4: DrawableResource by lazy {
      DrawableResource("drawable:V4", setOf(
        ResourceItem(setOf(), "${MD}drawable/V4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(787_213_116)
internal val Res.drawable.V40: DrawableResource by lazy {
      DrawableResource("drawable:V40", setOf(
        ResourceItem(setOf(), "${MD}drawable/V40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_112_303_043)
internal val Res.drawable.V40A: DrawableResource by lazy {
      DrawableResource("drawable:V40A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V40A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-169_927_132)
internal val Res.drawable.V5: DrawableResource by lazy {
      DrawableResource("drawable:V5", setOf(
        ResourceItem(setOf(), "${MD}drawable/V5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_516_051_067)
internal val Res.drawable.V6: DrawableResource by lazy {
      DrawableResource("drawable:V6", setOf(
        ResourceItem(setOf(), "${MD}drawable/V6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-168_482_193)
internal val Res.drawable.V7: DrawableResource by lazy {
      DrawableResource("drawable:V7", setOf(
        ResourceItem(setOf(), "${MD}drawable/V7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-695_431_228)
internal val Res.drawable.V7A: DrawableResource by lazy {
      DrawableResource("drawable:V7A", setOf(
        ResourceItem(setOf(), "${MD}drawable/V7A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(344_403_832)
internal val Res.drawable.V7B: DrawableResource by lazy {
      DrawableResource("drawable:V7B", setOf(
        ResourceItem(setOf(), "${MD}drawable/V7B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_630_732_018)
internal val Res.drawable.V8: DrawableResource by lazy {
      DrawableResource("drawable:V8", setOf(
        ResourceItem(setOf(), "${MD}drawable/V8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(895_286_223)
internal val Res.drawable.V9: DrawableResource by lazy {
      DrawableResource("drawable:V9", setOf(
        ResourceItem(setOf(), "${MD}drawable/V9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_495_195_430)
internal val Res.drawable.W1: DrawableResource by lazy {
      DrawableResource("drawable:W1", setOf(
        ResourceItem(setOf(), "${MD}drawable/W1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(956_986_833)
internal val Res.drawable.W10: DrawableResource by lazy {
      DrawableResource("drawable:W10", setOf(
        ResourceItem(setOf(), "${MD}drawable/W10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-185_196_246)
internal val Res.drawable.W10A: DrawableResource by lazy {
      DrawableResource("drawable:W10A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W10A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-592_349_289)
internal val Res.drawable.W11: DrawableResource by lazy {
      DrawableResource("drawable:W11", setOf(
        ResourceItem(setOf(), "${MD}drawable/W11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(200_615_830)
internal val Res.drawable.W12: DrawableResource by lazy {
      DrawableResource("drawable:W12", setOf(
        ResourceItem(setOf(), "${MD}drawable/W12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_018_908_969)
internal val Res.drawable.W13: DrawableResource by lazy {
      DrawableResource("drawable:W13", setOf(
        ResourceItem(setOf(), "${MD}drawable/W13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_125_209_255)
internal val Res.drawable.W14: DrawableResource by lazy {
      DrawableResource("drawable:W14", setOf(
        ResourceItem(setOf(), "${MD}drawable/W14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(435_944_157)
internal val Res.drawable.W14A: DrawableResource by lazy {
      DrawableResource("drawable:W14A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W14A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-55_543_619)
internal val Res.drawable.W15: DrawableResource by lazy {
      DrawableResource("drawable:W15", setOf(
        ResourceItem(setOf(), "${MD}drawable/W15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-981_617_590)
internal val Res.drawable.W16: DrawableResource by lazy {
      DrawableResource("drawable:W16", setOf(
        ResourceItem(setOf(), "${MD}drawable/W16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_532_290_524)
internal val Res.drawable.W17: DrawableResource by lazy {
      DrawableResource("drawable:W17", setOf(
        ResourceItem(setOf(), "${MD}drawable/W17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_231_403_658)
internal val Res.drawable.W17A: DrawableResource by lazy {
      DrawableResource("drawable:W17A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W17A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(618_778_551)
internal val Res.drawable.W18: DrawableResource by lazy {
      DrawableResource("drawable:W18", setOf(
        ResourceItem(setOf(), "${MD}drawable/W18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_016_756_958)
internal val Res.drawable.W18A: DrawableResource by lazy {
      DrawableResource("drawable:W18A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W18A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_089_106_485)
internal val Res.drawable.W19: DrawableResource by lazy {
      DrawableResource("drawable:W19", setOf(
        ResourceItem(setOf(), "${MD}drawable/W19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(329_264_186)
internal val Res.drawable.W2: DrawableResource by lazy {
      DrawableResource("drawable:W2", setOf(
        ResourceItem(setOf(), "${MD}drawable/W2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-213_696_219)
internal val Res.drawable.W20: DrawableResource by lazy {
      DrawableResource("drawable:W20", setOf(
        ResourceItem(setOf(), "${MD}drawable/W20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_918_636_404)
internal val Res.drawable.W21: DrawableResource by lazy {
      DrawableResource("drawable:W21", setOf(
        ResourceItem(setOf(), "${MD}drawable/W21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_136_795_525)
internal val Res.drawable.W22: DrawableResource by lazy {
      DrawableResource("drawable:W22", setOf(
        ResourceItem(setOf(), "${MD}drawable/W22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_025_586_562)
internal val Res.drawable.W23: DrawableResource by lazy {
      DrawableResource("drawable:W23", setOf(
        ResourceItem(setOf(), "${MD}drawable/W23.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable9Resources(map: MutableMap<String, DrawableResource>) {
  map.put("U7", Res.drawable.U7)
  map.put("U8", Res.drawable.U8)
  map.put("U9", Res.drawable.U9)
  map.put("V1", Res.drawable.V1)
  map.put("V10", Res.drawable.V10)
  map.put("V11", Res.drawable.V11)
  map.put("V11A", Res.drawable.V11A)
  map.put("V11B", Res.drawable.V11B)
  map.put("V11C", Res.drawable.V11C)
  map.put("V12", Res.drawable.V12)
  map.put("V12A", Res.drawable.V12A)
  map.put("V12B", Res.drawable.V12B)
  map.put("V13", Res.drawable.V13)
  map.put("V14", Res.drawable.V14)
  map.put("V15", Res.drawable.V15)
  map.put("V16", Res.drawable.V16)
  map.put("V17", Res.drawable.V17)
  map.put("V18", Res.drawable.V18)
  map.put("V19", Res.drawable.V19)
  map.put("V1A", Res.drawable.V1A)
  map.put("V1B", Res.drawable.V1B)
  map.put("V1C", Res.drawable.V1C)
  map.put("V1D", Res.drawable.V1D)
  map.put("V1E", Res.drawable.V1E)
  map.put("V1F", Res.drawable.V1F)
  map.put("V1G", Res.drawable.V1G)
  map.put("V1H", Res.drawable.V1H)
  map.put("V1I", Res.drawable.V1I)
  map.put("V2", Res.drawable.V2)
  map.put("V20", Res.drawable.V20)
  map.put("V20A", Res.drawable.V20A)
  map.put("V20B", Res.drawable.V20B)
  map.put("V20C", Res.drawable.V20C)
  map.put("V20D", Res.drawable.V20D)
  map.put("V20E", Res.drawable.V20E)
  map.put("V20F", Res.drawable.V20F)
  map.put("V20G", Res.drawable.V20G)
  map.put("V20H", Res.drawable.V20H)
  map.put("V20I", Res.drawable.V20I)
  map.put("V20J", Res.drawable.V20J)
  map.put("V20K", Res.drawable.V20K)
  map.put("V20L", Res.drawable.V20L)
  map.put("V21", Res.drawable.V21)
  map.put("V22", Res.drawable.V22)
  map.put("V23", Res.drawable.V23)
  map.put("V23A", Res.drawable.V23A)
  map.put("V24", Res.drawable.V24)
  map.put("V25", Res.drawable.V25)
  map.put("V26", Res.drawable.V26)
  map.put("V27", Res.drawable.V27)
  map.put("V28", Res.drawable.V28)
  map.put("V28A", Res.drawable.V28A)
  map.put("V29", Res.drawable.V29)
  map.put("V29A", Res.drawable.V29A)
  map.put("V2A", Res.drawable.V2A)
  map.put("V3", Res.drawable.V3)
  map.put("V30", Res.drawable.V30)
  map.put("V30A", Res.drawable.V30A)
  map.put("V31", Res.drawable.V31)
  map.put("V31A", Res.drawable.V31A)
  map.put("V32", Res.drawable.V32)
  map.put("V33", Res.drawable.V33)
  map.put("V33A", Res.drawable.V33A)
  map.put("V34", Res.drawable.V34)
  map.put("V35", Res.drawable.V35)
  map.put("V36", Res.drawable.V36)
  map.put("V37", Res.drawable.V37)
  map.put("V37A", Res.drawable.V37A)
  map.put("V38", Res.drawable.V38)
  map.put("V39", Res.drawable.V39)
  map.put("V4", Res.drawable.V4)
  map.put("V40", Res.drawable.V40)
  map.put("V40A", Res.drawable.V40A)
  map.put("V5", Res.drawable.V5)
  map.put("V6", Res.drawable.V6)
  map.put("V7", Res.drawable.V7)
  map.put("V7A", Res.drawable.V7A)
  map.put("V7B", Res.drawable.V7B)
  map.put("V8", Res.drawable.V8)
  map.put("V9", Res.drawable.V9)
  map.put("W1", Res.drawable.W1)
  map.put("W10", Res.drawable.W10)
  map.put("W10A", Res.drawable.W10A)
  map.put("W11", Res.drawable.W11)
  map.put("W12", Res.drawable.W12)
  map.put("W13", Res.drawable.W13)
  map.put("W14", Res.drawable.W14)
  map.put("W14A", Res.drawable.W14A)
  map.put("W15", Res.drawable.W15)
  map.put("W16", Res.drawable.W16)
  map.put("W17", Res.drawable.W17)
  map.put("W17A", Res.drawable.W17A)
  map.put("W18", Res.drawable.W18)
  map.put("W18A", Res.drawable.W18A)
  map.put("W19", Res.drawable.W19)
  map.put("W2", Res.drawable.W2)
  map.put("W20", Res.drawable.W20)
  map.put("W21", Res.drawable.W21)
  map.put("W22", Res.drawable.W22)
  map.put("W23", Res.drawable.W23)
}
